import * as React from 'react';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';

const RiskPlaceOrderPopup = (props) => {
    const { SetStatus, data } = props;
    const [isCreditRiskAlert, setCreditRiskAlert] = useReduxState('','setCreditRiskAlert');

    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Place Order Message</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            <>
                                <p className='mb-0 mt-3 text-center'>Due to Payment in Advance requirement your order may be delayed.
                                    In case of questions reach out to your local Sales Representative.</p>
                            </>

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-sm btn-primary" data-dismiss="modal"
                                onClick={() => {
                                    /**
                                     * Make callback for the place order on click of ok
                                     * Author: Devanshi Patel
                                     */
                                    data.onClickOk()
                                    setTimeout(() => {
                                        System.alert('Due to Payment in Advance requirement your order may be delayed. In case of questions reach out to your local Sales Representative.', 'warning');
                                    }, 500);
                                    setCreditRiskAlert(false)
                                    SetStatus(false)
                                }}>
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RiskPlaceOrderPopup;